import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common'

@Component({
  selector: 'sot-user',
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"]
})
export class User {
  public loggedIn=false;

  LoginClick(){
    this.loggedIn=true;
  }

  LogoutClick(){
    this.loggedIn=false;
  }
  /*
  public loggedin=true;
 
  
  LogoutClick(){
    this.loggedin=false;
  }

  LoginClick(){
    this.loggedin=true;
  }
 

  onLogin(){
    console.log("function called");

  }

  onLogout(){
    console.log("function called");
  }`*/




}